import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from "../utils/config.service";
import { BaseService } from "./base.service";
import { Subject } from "rxjs/Rx";

@Injectable()
export class AuthService extends BaseService {
  private user = new Subject<any>();
  client: any = {};
  subDomain: string = '';
  baseUrl: string = '';
  baseApiUrl: string = '';
  loginApiUrl: string = '';
  forgotApiUrl: string = '';
  resetApiUrl: string = '';
  callBackUrl: string = '';
  roleApiUrl: string = '';
  userCreateApiUrl: string = '';
  userListApiUrl: string = '';
  userGetApiUrl: string = '';
  sendVerificationEmailApiUrl: string = '';
  userVerifyApiUrl: string = '';
  changeApiUrl: string = '';
  deactivateUserApiUrl: string = '';
  reactivateUserApiUrl: string = '';
  getUserByUserNameUrl: string = '';
  sendVerificationEmailToUserAndAdminApiUrl: string = '';
  updateLoginRecordUrl: string = '';

  public getUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  public updateUser(user) {
    this.user.next(user);
  }

  getUpdatedUser() {
    return this.user.asObservable();
  }

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseApiUrl = this.configService.getApiURI();
    this.baseUrl = this.configService.getBaseApiURI();

    this.loginApiUrl = this.baseApiUrl + '/authentication/login';
    this.forgotApiUrl = this.baseApiUrl + '/authentication/ForgetPassword';
    this.resetApiUrl = this.baseApiUrl + '/authentication/ResetPassword';
    this.callBackUrl = this.baseUrl + '/#/auth/reset-password';
    this.roleApiUrl = this.baseApiUrl + '/authentication/role/list';
    this.userCreateApiUrl = this.baseApiUrl + '/authentication/user/post';
    this.userListApiUrl = this.baseApiUrl + '/authentication/user/list';
    this.userGetApiUrl = this.baseApiUrl + '/authentication/user/get';
    this.sendVerificationEmailApiUrl = this.baseApiUrl + '/authentication/user/sendVerificationEmail';
    this.userVerifyApiUrl = this.baseApiUrl + '/authentication/user/userVerify';
    this.changeApiUrl = this.baseApiUrl + '/authentication/ChangePassword';
    this.deactivateUserApiUrl = this.baseApiUrl + '/authentication/deactivateUser';
    this.reactivateUserApiUrl = this.baseApiUrl + '/authentication/reactivateUser';
    this.getUserByUserNameUrl = this.baseApiUrl + '/authentication/GetUserByUserName';
    this.sendVerificationEmailToUserAndAdminApiUrl = this.baseApiUrl + '/authentication/Auth/sendVerificationEmailToUserAndAdmin';
    this.updateLoginRecordUrl = this.baseApiUrl + '/login/UpdateLoginData';
  }

  login(username: string, password: string) {
    return this.http.post<any>(this.loginApiUrl, { username: username, password: password })
      .map(response => {
        // login successful if there's a jwt token in the response
        let user = response;

        if (user && user.auth_token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          user.user.PasswordHash = "";
          user.user.SecurityStamp = "";

          localStorage.setItem('currentUser', JSON.stringify(user));
          this.updateUser(user);

          return user;
        }

      }
      ).catch(this.handleError);
  }


  forgotPassword(email: string, supportEmail: string) {
    return this.http.post(this.forgotApiUrl, { email: email, callBackUrl: this.callBackUrl, fromEmail: supportEmail })
      .catch(this.handleError);
  }


  resetPassword(newPassword: string, newConfirmPassword: string, userId: string, code: string) {
    return this.http.post(this.resetApiUrl, { userId: userId, password: newPassword, confirmPassword: newConfirmPassword, code: code })
      .catch(this.handleError);
  }

  logout() {
    localStorage.clear();


  }

  listUsers(clientId: number) {
    return this.http.get<any>(this.userListApiUrl + '/' + clientId)
      .map(response => response)
      .catch(this.handleError);
  }

  getRoles() {
    return this.http.get<any>(this.roleApiUrl, {})
      .map(response => response)
      .catch(this.handleError);
  }

  getSiteUrl() {
    var url = window.location.origin + "/";
    return url;
  }
  register(data: any) {
    data.siteUrl = this.getSiteUrl();
    return this.http.post<any>(this.userCreateApiUrl, data)
      .map(response => response)
      .catch(this.handleError);
  }

  getUserFromDatabase(id: string) {
    return this.http.get<any>(this.userGetApiUrl + '/' + id.toString())
      .map(response => response)
      .catch(this.handleError);
  }

  // Send Verification Email
  sendVerificationEmail(userId: string, clientId: number, email: string) {
    try {
      return this.http.get(this.sendVerificationEmailApiUrl + '/' + userId + '/' + clientId + '/' + email)
        .map(response => response)
        .catch(this.handleError);
    } catch (ex) {
      throw ex;
    }
  }

  // User Verify
  userVerify(userId: string, email: string) {
    try {
      return this.http.get(this.userVerifyApiUrl + '/' + userId + '/' + email)
        .map(response => response)
        .catch(this.handleError);
    } catch (ex) {
      throw ex;
    }
  }

  changePassword(currentPassword: string, newPassword: string, userId: string) {
    return this.http.post(this.changeApiUrl, { userId: userId, currentPassword: currentPassword, newPassword: newPassword })
      .catch(this.handleError);
  }

  deactivateUser(userId: string) {
    return this.http.get(this.deactivateUserApiUrl + '/' + userId)
      .catch(this.handleError);
  }
  reactivateUser(userId: string) {
    return this.http.get(this.reactivateUserApiUrl + '/' + userId)
      .catch(this.handleError);
  }

  getUserByUserName(userName: string) {
    return this.http.get(this.getUserByUserNameUrl + '/' + userName)
      .catch(this.handleError);
  }

  // Send Verification Email
  async sendVerificationEmailToUserAndAdmin(notificationModel: any) {
    try {
      return await this.http.post<any>(this.sendVerificationEmailToUserAndAdminApiUrl, notificationModel)
        .map(response => response)
        .catch(this.handleError);

    } catch (ex) {
      throw ex;
    }
  }

  // Record update when logout user
  updateLoginRecord(userName: string) {
    return this.http.post(this.updateLoginRecordUrl, { userName: userName }).map(response => {
      let user = response;
    }).catch(this.handleError);
  }
}
